import * as React from 'react';
import Layout from '../layout';
import { ConfirmWrapper, ConfirmMessage, ConfirmTitle, ConfirmContent, Sep, ResumeVideo, ShareTitle, ShareList, ShareListItem } from './styled';
import { colors } from '../../variables';
import { Button, MobileMask } from '../../widgets/globaleStyledWidget';
import icoFacebook from './images/ico-facebook.png';
import icoInsta from './images/ico-instagram.png';
import icoTwitter from './images/ico-twitter.png';
import icoPinterest from './images/ico-pinterest.svg';
import icoYoutube from './images/ico-youtube.png';
import icoLinkedin from './images/ico-linkedin.svg';

import {FormattedMessage, injectIntl, useIntl} from 'react-intl';
import livstickApp from '../../models/livstick';

import videojs from 'video.js';
import manifest from '../../manifest';

const videoJsOptions = {
  controls: true,
  bigPlayButton: true,
  fluid: true,
};


const EndPage:React.FunctionComponent = () => {

  const videoEl = React.useRef(null);

  const intl = useIntl();

  const start = async () => {
    const _res = await livstickApp.pullNoLog();
    

    console.log('ref', videoEl)
    var _player = videojs(videoEl.current, videoJsOptions, () => {
      const version_info = 'Using video.js ' + videojs.VERSION;
      videojs.log(version_info);
      _player.src({ src: _res.media_url });
      _player.load();
      //_player.play();
    });

  }

  React.useEffect(() => {
    start();
  }, [])
    return <Layout>
      <ConfirmWrapper>
        <ConfirmContent>
          <ResumeVideo>
            <video id="myVideo" ref={videoEl} className="video-js vjs-default-skin" playsInline></video>
          </ResumeVideo>
          {manifest.VM && <p>https://mm2.fr/liv4/vm.html#/{livstickApp.code}</p>}
          <ConfirmTitle><FormattedMessage id="form_txt_success_title"/></ConfirmTitle>
          {/* {livstickApp.planification && <>Votre message sera envoyé le {moment()}</>} */}
          {/* <FormattedMessage id="form_txt_sent" defaultMessage="Votre message sera envoyé le ..."/> */}
          <ConfirmMessage><FormattedMessage id="form_txt_success"/></ConfirmMessage>
          {/*<Button color={colors.main} hover="main"><FormattedMessage id="form_txt_button_edit"/></Button>*/}
          {/* ROMAIN : Ajout pour HO */}
          <Sep/>
          
          <ShareList>
            <ShareListItem color={colors.facebook}><a href={intl.formatMessage({id:'share_txt_facebook'})} target="_blank"><img src={icoFacebook} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_instagram'})} target="_blank"><img src={icoInsta} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_twitter'})} target="_blank"><img src={icoTwitter} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_youtube'})} target="_blank"><img src={icoYoutube} /></a></ShareListItem>
          </ShareList>
          
        </ConfirmContent>
      </ConfirmWrapper>

    </Layout>;
}

export default injectIntl(EndPage);